/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container, Row } from "reactstrap";

// core components

function FooterBlack() {
  return (
    <>
      <footer className="footer footer-white">
        <Container>
          <Row>
            <nav className="footer-nav">
              <ul>
                <li>
                  <a href="./" target="_blank" className="mr-1">
                    JeufZone
                  </a>
                </li>
                <li>
                  <a href="#" target="_blank">
                    Licenses
                  </a>
                </li>
              </ul>
            </nav>
            <div className="credits ml-auto">
              <a href="https://hopelapp.com/" target="_blank" className="mr-1">
                <span className="copyright">
                  © {new Date().getFullYear()}, Made by Hopelapp 🫰
                </span>
              </a>
            </div>
          </Row>
        </Container>
      </footer>
    </>
  );
}

export default FooterBlack;
